import { useState, useRef, useEffect } from "react";
import { TextField } from "@material-ui/core";
import SingleDropDown from "../SingleDropDown";
import ToggleButtons from "./ToggleButtons";
import TooltipIcon from "../TooltipIcon/TooltipIcon";

const _spacing = "10px";

const XqForm = props => {
  const inputLabel = useRef(null);
  const [labelWidth, setLabelWidth] = useState(0);
  const [toggleOption, setToggleOption] = useState(0);

  useEffect(() => {
    if (inputLabel.current) {
      setLabelWidth(inputLabel.current.offsetWidth);
    }
  }, []);

  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  const Plate = () => {
    return (
      <TextField
        variant="outlined"
        data-cy="licensePlateNumber"
        inputProps={{ "data-cy": "licensePlateNumber-input" }}
        InputLabelProps={{
          shrink: true,
          "data-cy": "licensePlateNumber-input-label",
        }}
        margin="dense"
        id="licensePlateNumber-id"
        label="License Plate Number"
        value={props?.queryState?.licensePlateNumber || ""}
        onChange={handleChange}
        name="licensePlateNumber"
        style={{ width: "45%" }}
      />
    );
  };

  const Vin = () => {
    return (
      <TextField
        variant="outlined"
        data-cy="vin"
        inputProps={{ "data-cy": "vin-input" }}
        InputLabelProps={{ shrink: true, "data-cy": "vin-input-label" }}
        margin="dense"
        id="vin-id"
        label="VIN"
        value={props?.queryState?.vin || ""}
        helperText="No dashes or spaces"
        onChange={handleChange}
        name="vin"
        style={{ width: "45%" }}
      />
    );
  };

  const formOptions = [Plate, Vin];

  return (
    <div
      data-testid="xq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[{ name: "Plate" }, { name: "VIN" }]}
        callback={setToggleOption}
      />
      <div
        id="group1"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
      <div style={{ display: "flex", alignItems: "center", columnGap: "5px" }}>
        <p style={{ fontWeight: "bold", margin: 0 }}>Conditional Fields</p>
        <TooltipIcon
          hoverText="These fields may be required or not allowed"
          text="These fields may be required or not allowed based on the state selected in the Destination field above. Refer to the state-specific guidelines from NLETs for more information."
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <SingleDropDown
          title={"Reason Code"}
          value={props?.queryState?.reasonCode}
          stateName={"reasonCode"}
          options={props.reasonCodes}
          handleChange={handleChange}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={false}
          name={"fullName"}
          // canEdit={true}
          // userRoles={props.user?.roleNames}
        />
        <SingleDropDown
          title={"Property In Sight"}
          value={props?.queryState?.propInSight}
          stateName={"propInSight"}
          options={props.propInSights}
          handleChange={handleChange}
          inputLabel={inputLabel}
          labelWidth={labelWidth}
          disabled={false}
          name={"fullName"}
        />
      </div>
    </div>
  );
};

export default XqForm;
